const settings = {
  baseURL: import.meta.env.VITE_BASE_URL,
  fileUrl: import.meta.env.VITE_FILE_URL,
  requestTimeout: 60000 * 5,
  staleTime: 2000 * 60 * 2,
  idleTimeout: 3000,
};

export default settings;
